const imageData = {
  Americas: {
    Argentina:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Argentina.png",
    Belize: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Belize.png",
    Bermuda:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Bermuda.png",
    Bolivia:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Bolivia.png",
    Brazil: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Brazil.png",
    Canada: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Canada.png",
    "Cayman Islands":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Cayman_Islands.png",
    Chile: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Chile.png",
    Colombia:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Colombia.png",
    "Costa Rica":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Costa_Rica.png",
    Cuba: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Cuba.png",
    Curaçao:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Curacao.png",
    "Dominican Republic":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Dominican_Republic.png",
    Ecuador:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Ecuador.png",
    "El Salvador":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/El_Salvador.png",
    "French Guiana":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/French_Guiana.png",
    Grenada:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Grenada.png",
    Guatemala:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Guatemala.png",
    Guyana: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Guyana.png",
    Honduras:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Honduras.png",
    Jamaica:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Jamaica.png",
    Mexico: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Mexico.png",
    Panama: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Panama.png",
    Paraguay:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Paraguay.png",
    Peru: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Peru.png",
    "Puerto Rico":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Puerto_Rico.png",
    Suriname:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Suriname.png",
    "Trinidad and Tobago":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Trinidad_and_Tobago.png",
    "Turks and Caicos Islands":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Turks_and_Caicos_Islands.png",
    "United States":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/United_States.png",
    Uruguay:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Uruguay.png",
    Venezuela:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Venezuela.png",
    "Virgin Islands, British":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Virgin_Islands_British.png",
    "Virgin Islands, U.S.":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Virgin_Islands_U.S..png",
  },
  "Asia Pacific": {
    Australia:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Australia.png",
    Bangladesh:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Bangladesh.png",
    Bhutan: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Bhutan.png",
    Brunei: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Brunei.png",
    Burma: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Burma.png",
    Cambodia:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Cambodia.png",
    China: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/China.png",
    Fiji: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Fiji.png",
    "Hong Kong":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Hong_Kong.png",
    India: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/India.png",
    Indonesia:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Indonesia.png",
    Japan: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Japan.png",
    Kazakhstan:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Kazakhstan.png",
    Kyrgyzstan:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Kyrgyzstan.png",
    "Lao People's Democratic Republic":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Lao_People_s_Democratic_Republic.png",
    Macau: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Macau.png",
    Malaysia:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Malaysia.png",
    Maldives:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Maldives.png",
    Mongolia:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Mongolia.png",
    Nepal: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Nepal.png",
    "New Caledonia":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/New_Caledonia.png",
    "New Zealand":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/New_Zealand.png",
    Pakistan:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Pakistan.png",
    "Papua New Guinea":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Papua_New_Guinea.png",
    Philippines:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Philippines.png",
    Singapore:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Singapore.png",
    "South Korea":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/South_Korea.png",
    "Sri Lanka":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Sri_Lanka.png",
    Taiwan: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Taiwan.png",
    Thailand:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Thailand.png",
    "Timor-Leste":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Timor-Leste.png",
    Uzbekistan:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Uzbekistan.png",
    Vietnam:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Vietnam.png",
  },
  Europe: {
    Albania:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Albania.png",
    Andorra:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Andorra.png",
    Armenia:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Armenia.png",
    Austria:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Austria.png",
    Azerbaijan:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Azerbaijan.png",
    Belarus:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Belarus.png",
    Belgium:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Belgium.png",
    "Bosnia and Herzegovina":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Bosnia_and_Herzegovina.png",
    Bulgaria:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Bulgaria.png",
    Croatia:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Croatia.png",
    Cyprus: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Cyprus.png",
    "Czech Republic":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Czech_Republic.png",
    Denmark:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Denmark.png",
    Estonia:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Estonia.png",
    Finland:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Finland.png",
    France: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/France.png",
    Georgia:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Georgia.png",
    Germany:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Germany.png",
    Greece: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Greece.png",
    Guernsey:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Guernsey.png",
    Gibraltar:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Gibraltar.png",
    Hungary:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Hungary.png",
    Iceland:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Iceland.png",
    Ireland:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Ireland.png",
    Italy: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Italy.png",
    Jersey: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Jersey.png",
    Kosovo: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Kosovo.png",
    Latvia: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Latvia.png",
    Liechtenstein:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Liechtenstein.png",
    Lithuania:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Lithuania.png",
    Luxembourg:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Luxembourg.png",
    Malta: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Malta.png",
    "Moldova, Republic of":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Moldova_Republic_of.png",
    Monaco: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Monaco.png",
    Montenegro:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Montenegro.png",
    Netherlands:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Netherlands.png",
    "North Macedonia":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/North_Macedonia.png",
    Norway: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Norway.png",
    Poland: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Poland.png",
    Portugal:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Portugal.png",
    Romania:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Romania.png",
    Russia: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Russia.png",
    "San Marino":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/San_Marino.png",
    Serbia: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Serbia.png",
    Slovakia:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Slovakia.png",
    Slovenia:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Slovenia.png",
    Spain: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Spain.png",
    Sweden: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Sweden.png",
    Switzerland:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Switzerland.png",
    Ukraine:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Ukraine.png",
    "United Kingdom":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/United_Kingdom.png",
  },
  "Middle East & Africa": {
    Algeria:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Algeria.png",
    Angola: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Angola.png",
    Bahrain:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Bahrain.png",
    Benin: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Benin.png",
    Botswana:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Botswana.png",
    "Burkina Faso":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Burkina_Faso.png",
    Cameroon:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Cameroon.png",
    "Cape Verde":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Cape_Verde.png",
    "Congo, the Democratic Republic of the":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Congo_the_Democratic_Republic_of_the.png",
    Congo: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Congo.png",
    Egypt: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Egypt.png",
    Gabon: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Gabon.png",
    Gambia: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Gambia.png",
    Ghana: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Ghana.png",
    "Iran, Islamic Republic of":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Iran_Islamic_Republic_of.png",
    Iraq: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Iraq.png",
    Israel: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Israel.png",
    "Ivory Coast":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Ivory_Coast.png",
    Jordan: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Jordan.png",
    Kenya: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Kenya.png",
    Kuwait: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Kuwait.png",
    Lebanon:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Lebanon.png",
    Libya: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Libya.png",
    Malawi: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Malawi.png",
    Mali: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Mali.png",
    Mauritius:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Mauritius.png",
    Morocco:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Morocco.png",
    Mozambique:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Mozambique.png",
    Namibia:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Namibia.png",
    Oman: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Oman.png",
    "Palestinian Territory, Occupied":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Palestinian_Territory_Occupied.png",
    Qatar: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Qatar.png",
    Rwanda: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Rwanda.png",
    Réunion:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Reunion.png?v=1744013878",
    "Saudi Arabia":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Saudi_Arabia.png",
    Senegal:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Senegal.png",
    Seychelles:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Seychelles.png",
    "Sierra Leone":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Sierra_Leone.png",
    "South Africa":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/South_Africa.png",
    "St. Vincent and the Grenadines":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/St._Vincent_and_the_Grenadines.png",
    Sudan: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Sudan.png",
    "Syrian Arab Republic":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Syrian_Arab_Republic.png",
    "Tanzania, United Republic of":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Tanzania_United_Republic_of.png",
    Tunisia:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Tunisia.png",
    Turkey: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Turkey.png",
    Uganda: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Uganda.png",
    "United Arab Emirates":
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/United_Arab_Emirates.png",
    Yemen: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Yemen.png",
    Zambia: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Zambia.png",
    Zimbabwe:
      "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/Zimbabwe.png",
  },
};
